import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  ExcelService,
  OrganizationTransactionsService,
  OutBoxMessagesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { AppOrganizationTransaction } from 'src/app/core/types/app-organization-transaction.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import {
  CustomResultOfGetOrganizationTransactionByIdDto,
  GetOrganizationTransactionByIdDto,
  LogicalComparisonOperator,
  TransactionsWithPaginationDto,
  TransactionsWithPaginationItemDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { TypeTransactions } from './../../../core/api/models/type-transactions';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { CreateTransactionsExcelDialogComponent } from './create-transactions-excel/create-transactions-excel-dialog.component';
import { PageNames } from '../../../configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';
import { OrganizationTransactionsDetailComponent } from './organization-transactions-detail/organization-transactions-detail.component';
import { OrganizationTransactionsFormComponent } from './organization-transactions-form/organization-transactions-form.component';

@Component({
    selector: 'app-organization-transactions',
    templateUrl: './organization-transactions.component.html',
    styleUrls: ['./organization-transactions.component.scss'],
    imports: [
        BaseIndexModule,
        TextPopoverDirective,
        OrganizationTransactionsDetailComponent,
        OrganizationTransactionsFormComponent
    ]
})
export class OrganizationTransactionsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  @Input('organizationId') input_organizationId: number;
  @Input('organizationTransactionType')
  input_organizationTransactionType: AppOrganizationTransaction =
    'organizationTransaction';

  pageName = PageNames.organizationTransactions;
  modelWithPagination$: Observable<TransactionsWithPaginationDto>;
  items$: Observable<Array<TransactionsWithPaginationItemDto>>;
  formPageConfig: FormPageConfig<any> = {};
  totalSum: number;
  fontSize: AppFontSize = 'sm';

  //enums
  TypeCreditChangesEnumValues: GetEnumValuesDto[] = [];
  TypeTransactionsEnumValues: GetEnumValuesDto[] = [];
  scheduledMessageId: any;
  detailModel: GetOrganizationTransactionByIdDto;
  isShowDetail: boolean;

    // API method bindings
    protected currentService = inject(OrganizationTransactionsService);
    createGetApiMethodName: string = this.currentService.organizationTransactionsCreateTransactionForOrganizationGet.name;
    auditApiMethodName: string = this.currentService.organizationTransactionsGetOrganizationTransactionsAudit.name;

  get TypeTransactions() {
    return TypeTransactions;
  }

  @Output('onBack') output_closePage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    public outBoxMessagesService: OutBoxMessagesService,
    protected excelFileService: ExcelService,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    if (window.location.search == '') {
      this.setDefaultDateSearch();
      this.setDefaultTableSort();
    }

    if (
      this.input_organizationTransactionType ==
      'organizationTransactionByOrganizationId'
    ) {
      this.pageConfig.showRefreshBtn = true;
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.showAuditBtn = false;
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Details_key)
        this.onDetail(value.toString(), false);
    }
  }

  onShowCustomFields(id: number) {}

  getEnumsValues() {
    this.getEnumValuesApi('TypeTransactions')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeTransactionsEnumValues = values));
    this.getEnumValuesApi('TypeCreditChanges')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeCreditChangesEnumValues = values));
  }

  onShowOtherRows(num: number) {
    const iconEl = document.getElementById('icon_' + num);
    const el1 = document.querySelectorAll(`[data-group="${num}"]`);

    if (iconEl.classList.contains('mdi-plus-circle')) {
      el1.forEach((element) => {
        element.classList.remove('d-none');
      });
      iconEl.classList.remove('mdi-plus-circle');
      iconEl.classList.remove('text-success');
      iconEl.classList.add('mdi-minus-circle');
      iconEl.classList.add('text-danger');
    } else {
      el1.forEach((element) => {
        if (element.getAttribute('data-parent') == 'false')
          element.classList.add('d-none');
      });

      iconEl.classList.add('mdi-plus-circle');
      iconEl.classList.add('text-success');
      iconEl.classList.remove('mdi-minus-circle');
      iconEl.classList.remove('text-danger');
    }
  }
  defaultFilters = [
    {
      field: 'createdAt',
      operator: 3,
      value: DateTimeService.getTodayDate().toUTC(),
    },
    {
      field: 'createdAt',
      operator: 4,
      value: DateTimeService.getSimpleTodayDate().toUTC(),
    },
  ];
  setDefaultDateSearch() {
    try {
      let greaterThan = {
        field: 'createdAt',
        operator: 3,
        value: DateTimeService.getTodayDate().toUTC(),
      };

      let lessThan = {
        field: 'createdAt',
        operator: 4,
        value: DateTimeService.getSimpleTodayDate().toUTC(),
      };

      this.comparisonObjects.push({
        comparisonObjects: [greaterThan, lessThan],
        logicalComparisonOperator: LogicalComparisonOperator.And,
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.user,
        name: 'userName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.amount,
        name: 'amount',
        hasSearch: true,
        type: 'number',
        needCurrency: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}currentCredit`,
        name: 'currentCredit',
        hasSearch: true,
        type: 'number',
        needCurrency: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}typeTransaction`,
        name: 'typeTransaction',
        hasSearch: true,
        type: 'enum',
        enumName: 'TypeTransactions',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}typeCreditChange`,
        name: 'typeCreditChange',
        hasSearch: true,
        type: 'enum',
        enumName: 'TypeCreditChanges',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}packageId`,
        name: 'packageId',
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}packageTitle`,
        name: 'packageTitle',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}outboxId`,
        name: 'outboxId',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}paymentId`,
        name: 'paymentId',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
        wrap: true,
      },
      {
        title: this.localizer.description,
        name: 'description',
        noSorting: false,
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'createdAt',
        hasSearch: true,
        type: 'dateTime',
        dateDefaultValue: DateTimeService.getTodayDate().toUTC(),
        defaultDateType: 'both',
        wrap: true,
      },
    ];
  }

  //#region initial methods

  setDefaultTableSort() {
    const isExistsSortObject = this.sortObject.some((item) =>
      item.columnName.includes('createdAt')
    );
    if (!isExistsSortObject)
      this.sortObject.push({ columnName: 'createdAt', sort: 1 });
  }

  onClearQueryString() {
    this.tabsDynamicComponent.refreshTab(this.pageName);
  }
  //#endregion

  //#region Api

  //Get All
  getPaginationApi(): Observable<TransactionsWithPaginationDto> {
    if (this.input_organizationTransactionType == 'organizationTransaction')
      return this.currentService
        .organizationTransactionsGetOrganizationTransactionsWithPagination({
          body: this.getBaseModelWithPaginationParams(),
        })
        .pipe(
          tap((items: any) => {
            this.calculateTotalSum(items?.data?.items);
          })
        );
    else
      return this.currentService
        .organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination(
          {
            body: {
              ...this.getBaseModelWithPaginationParams(),
              organizationId: this.input_organizationId,
            },
          }
        )
        .pipe(
          tap((items: any) => {
            this.calculateTotalSum(items?.data?.items);
          })
        );
  }

  baseGetByIdApi(id: string): void {
    this.unSubs();

    this.currentService
      .organizationTransactionsGetOrganizationTransactionById({ id })
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfGetOrganizationTransactionByIdDto) => {
        this.detailModel = res.data;
        this.isShowDetail = true;
      });
  }

  TransactionsExcelReportApi() {
    this.excelFileService
      .excelCreateTransactionsExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}transactionsExcel`,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
            methodName: 'excelCreateTransactionsExcelPost',
          };
          
          const modalResult = this.dialogService.openModal({
            component: CreateTransactionsExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }
  //#endregion

  calculateTotalSum(items: any[]) {
    try {
      let pageTotalSum = 0;
      items.map((itemP) =>
        itemP.items.map((item) => (pageTotalSum += item.amount))
      );
      this.totalSum = pageTotalSum;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onDetail(id: string, setUrl = true) {
    this.showParent = false;
    this.pageConfig.loading = true;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          id
      );
    }
    this.baseGetByIdApi(id);
  }

  onCloseDetail() {
    this.showParent = true;
    this.getParentQueryString();

    this.isShowDetail = false;
  }

  onExcelReport() {
    this.TransactionsExcelReportApi();
  }

  emitOnBack() {
    this.output_closePage.emit(true);
  }
}
